'use strict';

import dispatcher from '../dispatcher';
import {EventEmitter} from '../utils';


let eventEmitter = new EventEmitter();
let initialized = false;
let items = {};

function _handleEvent(e) {
  switch (e.type){
    case ('slider-remove') :
      delete items[e.id];
      break;
    case ('slider-add') :
    case ('slider-change') :
      items[e.slider.id] = e.slider;
      eventEmitter.dispatch(_getData('slider-emit'));
      break;
    case ('slider-navigate') :
      if (!items.hasOwnProperty(e.slider)) return;
      let slider = items[e.slider];
      let oldActiveStart = slider.activeStart;

      if (e.direction !== undefined) {
        if (e.direction === 'next') {
          slider.activeStart++;

          if (slider.activeStart > slider.total - slider.activeCount) slider.activeStart = oldActiveStart;
        } else if (e.direction === 'prev') {
          slider.activeStart--;

          if (slider.activeStart < 0) slider.activeStart = 0;
        }
      } else if (e.slide !== undefined) {
        if (e.slide >= 0 && e.slide <= items[e.slider].total - slider.activeCount ) {
          slider.activeStart = e.slide;
        }
      }

      if (oldActiveStart !== slider.activeStart) eventEmitter.dispatch(_getData('navigation-emit'));
      break;
    case ('slider-enable-change') :
      items[e.id].disabled = e.disabled;
      eventEmitter.dispatch(_getData('slider-enable-emit'));
      break;
  }
}




function _getData(type) {
  return {
    type: type,
    _module: 'slider.store',
    items: items
  }
}

function _init() {
  dispatcher.subscribe(_handleEvent);
  initialized = true;
}

if (!initialized) _init();

export default {
  eventEmitter: eventEmitter,
  getData: _getData.bind(null, undefined)
}